import { render } from "./ArticlesForm.vue?vue&type=template&id=e9cffb2a&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ArticlesForm.vue?vue&type=script&lang=js"
export * from "./ArticlesForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/giovanialves/Documents/projects/vue/web.vidalonga/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__